import { render, staticRenderFns } from "./ExFoldMail.vue?vue&type=template&id=3f70c7bd&scoped=true"
import script from "./ExFoldMail.vue?vue&type=script&lang=js"
export * from "./ExFoldMail.vue?vue&type=script&lang=js"
import style0 from "./ExFoldMail.vue?vue&type=style&index=0&id=3f70c7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70c7bd",
  null
  
)

export default component.exports